import { GameTypeAbstract } from "../GameTypeAbstract";

export class SitngoTypeAbstract extends GameTypeAbstract {
}
